<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-parab"><a id="page_ii"></a>• <span class="smallcaps">FORGE BOOKS BY MACK MALONEY</span> •</p>
<p class="center-parab"><em>The Pirate Hunters<br/>Operation Caribe</em> (Pirate Hunters 2) coming in 2011</p>
<p class="center-parab">For a free Pirate Hunters patch,<br/>visit <a href="http://www.mackmaloney.com" target="_blank">www.mackmaloney.com</a>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?75314e65